import React, { useState } from 'react';
import styled from 'styled-components';
import { useAuth } from '../../contexts/AuthContext';
import { useData } from '../../contexts/DataContext';
import { useNavigate } from 'react-router-dom';
import ElevatedButton from '../Layout/ElevatedButton';

const Form = styled.form`
  max-width: 400px;
  margin: 2rem auto;
  padding: 2rem;
  border: 1px solid ${props => props.theme.buttonPrimary};
  border-radius: 8px;
  background: ${props => props.theme.cardBackground};
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  color: ${props => props.theme.text};
`;

const Input = styled.input`
  width: 100%;
  padding: 0.75rem 1.25rem;
  margin: 0.5rem 0;
  border: 2px solid ${props => props.theme.buttonPrimary};
  border-radius: 4px;
  font-size: 1rem;
  background: ${props => props.theme.inputBackground};
  color: ${props => props.theme.text};
  transition: all 0.3s ease;
  box-sizing: border-box;
  text-align: center;
  font-size: 1.5rem;
  letter-spacing: 0.5rem;

  &::placeholder {
    color: ${props => props.theme.textMuted};
    letter-spacing: normal;
  }

  &:focus {
    outline: none;
    border-color: ${props => props.theme.buttonPrimaryHover};
    background: ${props => props.theme.inputBackgroundFocus};
    box-shadow: 0 0 8px rgba(88, 101, 242, 0.3);
  }
`;

const TwoFactorForm = () => {
  const [token, setToken] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { verify2FA, twoFactorPending } = useAuth();
  const { prefetchData } = useData();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const result = await verify2FA(token);

    if (result.success) {
      // Prefetch all data before navigating to dashboard
      await prefetchData();
      navigate('/dashboard');
    } else {
      setError(result.error);
    }

    setLoading(false);
  };

  const handleTokenChange = (e) => {
    const value = e.target.value.replace(/\D/g, ''); // Only allow digits
    if (value.length <= 6) {
      setToken(value);
    }
  };

  if (!twoFactorPending) {
    return null;
  }

  return (
    <Form onSubmit={handleSubmit}>
      <h2 style={{ color: '#ffffff', textAlign: 'center', textShadow: '0 2px 4px rgba(0, 0, 0, 0.3)' }}>
        Two-Factor Authentication
      </h2>

      <p style={{ textAlign: 'center', color: '#b9bbbe', marginBottom: '1rem' }}>
        Enter the 6-digit code from your authenticator app
      </p>

      {error && (
        <div style={{
          padding: '0.75rem',
          marginBottom: '1rem',
          background: '#dc3545',
          color: 'white',
          borderRadius: '4px',
          textAlign: 'center'
        }}>
          {error}
        </div>
      )}

      <Input
        type="text"
        placeholder="000000"
        value={token}
        onChange={handleTokenChange}
        required
        disabled={loading}
        autoFocus
      />

      <ElevatedButton type="submit" style={{ width: '100%', marginTop: '1rem' }} disabled={loading || token.length !== 6}>
        {loading ? 'Verifying...' : 'Verify Code'}
      </ElevatedButton>
    </Form>
  );
};

export default TwoFactorForm;